<template lang="pug">
    .rec-bubble-wrap.clearfix
      .rec-bubble.xs-12
        .rec-bubble-title.xs-12.text-center
          p.xs-f-medium.lg-f-xmedium.max-at-tweak(v-html="title")

        .rec-bubble-preamble(v-if="!!preamble")
          p.xs-f-small.lg-f-medium.max-at-tweak(v-html="preamble")

        .rec-bubble-main-content
          slot

        .rec-bubble-cta-container
          .rec-bubble-cta-description(v-if="!!actionsDescription")
            p.xs-f-small.lg-f-medium.max-at-tweak Or, try the following option at home...
          .rec-bubble-cta-button-container(v-if="actions && actions.length")
            button.mr-btn.xs-f-xsmall.max-at-tweak(
              v-for="action in actions" 
              type="button" 
              @click="action.action ? action.action() : ''" 
              :class="{ 'btn-inverse': action.inverted, 'disabled':action.disabled }") 
                i.icon-check-nobox(v-if="action.checked")
                |&nbsp; {{ action.label }}
</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex';

  export default {
    name: "RecommendationsPanel",

    props: {
      title: {
        type: String,
        required: true
      },

      preamble: {
        type: String,
        required: false
      },

      actionsDescription: {
        type: String,
        required: false
      },

      actions: {
        type: Array,
        required: false
      },

      content: {
        type: Object,
        required: false
      }
    }
  }
</script>

<style lang="stylus">
  .rec-bubble-wrap
    padding 1em 15%
    display inline-block
    width 100%

  .rec-bubble  
    opacity 100
    transition(opacity 150ms 500ms ease-in)
    background-color white
    border 1px solid #ccc
    border-radius 0.5em
    margin-top 1em

    .rec-bubble-title
      padding 1.2em 5%
      border-bottom 1px solid #ccc

    .rec-bubble-preamble
      display inline-block
      text-align center
      width 100%
      padding 2em

      a
        text-decoration underline
      @media mq-mobile
        padding 1em

    .rec-bubble-main-content
      display inline-block
      width 100%
      text-align center
      &.contact
        background-color bg-color-info

    .rec-bubble-cta-container
      text-align center
      .rec-bubble-cta-description
        text-align center
        padding 1.5em
      .rec-bubble-cta-button-container
        padding-bottom 2em
        button
          margin-left 1em
          margin-right 1em
          min-width 35%
          &:last-child
            margin-bottom 0 
          &.disabled
            color color-gray-med !important

  @media mq-tablet-less
    .rec-bubble-cta-container
      .rec-bubble-cta-button-container
        button
          width 88%
          margin-bottom 1.5em

   @media mq-mobile
     .rec-bubble-wrap
       padding .5em 1.5em

</style>